import { sanitizeTextForAnalytics } from "@/utils/helper"

export const addDownloadFilesAnalytics = (
  productInfo = "",
  selectedFiles = [],
  hasError = false
) => {
  // add analytics
  const selectedFileList = []
  selectedFiles.forEach(selectedObj => {
    const fileNameAndFileType = (
      selectedObj.title +
      "." +
      selectedObj.type
    ).toLowerCase()
    selectedFileList.push(fileNameAndFileType)
  })

  if (selectedFileList.length && window.adobeDataLayer) {
    const kohlerDatalayer = window.kohler.datalayer
    kohlerDatalayer.publish(kohlerDatalayer.EventTypes.CLICK, {
      eventMetaData: {
        experience: "pdp",
        eventType: "downloadFilesAnalytics",
        params: {
          selectedFiles,
          hasError,
        },
      },
    })
  }
}

export const addDownloadFilesAnalyticsInstSup = (
  productInfo = "",
  type = "",
  errMsg = "",
  link = ""
) => {
  const title = type.toLowerCase().trim()
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    eventAction: `pdp:installation & support:guides:${title}`,
    eventName: `pdp:installation & support:guides:${title}`,
    eventType: "navigation",
    eventMsg: errMsg || "success",
    eventStatus: errMsg ? "failure" : "success",
    internalLinkName: `${title} | ${link.replace(
      "https://www.us.kohler.com/webassets",
      ""
    )}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:installation & support:${title}`,
    internalLinkZoneName: `pdp:installation & support`,
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  const dataLayerProductInfo = productInfo
    ? JSON.parse(productInfo)?.productInfo
    : null
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo: dataLayerProductInfo,
  })
}

export const getEventInfoProdAccordion = (
  type = "",
  tabName = "",
  needsJSON = false,
  link = "",
  errMsg = ""
) => {
  const text = type.toLowerCase().trim()
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventMsg = text === "view more" ? "n/a" : errMsg || "success"
  const eventStatus =
    text === "view more" ? "n/a" : errMsg ? "failure" : "success"
  const internalLinkName = `${text}${
    text === "specifications sheet"
      ? ` | ${link.replace("https://www.us.kohler.com/webassets", "")}`
      : ""
  }`
  const eventInfo = {
    eventAction: `${page?.category?.pageType}:${tabName}:${text}`,
    eventName: `${page?.category?.pageType}:${tabName}:${text}`,
    eventType: "navigation",
    eventMsg,
    eventStatus,
    internalLinkName,
    internalLinkPosition: `${page?.category?.pageType}`,
    internalLinkType: `${page?.category?.pageType}:${tabName}:${text}`,
    internalLinkZoneName: `${page?.category?.pageType}:${tabName}`,
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const accordianAnalyticsData = (
  type = "",
  isExpanded = false,
  needsJSON = false
) => {
  const title = type.toLowerCase().trim()
  const eventInfo = {
    eventAction: `pdp:product details:accordion ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventName: `pdp:product details:accordion ${
      isExpanded ? "collapse" : "expand"
    }`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${isExpanded ? "collapse" : "expand"}`,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${title}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const dimensionsTooltipAnalyticsData = (
  type = "",
  productInfo = null,
  message = "",
  needsJSON = false
) => {
  const title = type.toLowerCase().trim()
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    eventAction: `pdp:product details:${title} mouseover`,
    eventName: `pdp:product details:${title} mouseover`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: message,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:mouseover:${title}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needsJSON) {
    return eventInfo
  }
  const dataLayerProductInfo = productInfo
    ? JSON.parse(productInfo)?.productInfo
    : null
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo: dataLayerProductInfo,
  })
}

export const getEventInfoInstSup = (
  title = "",
  type = "",
  avoidTitle = false,
  url = ""
) => {
  const addedTitle = avoidTitle ? "" : ":" + sanitizeTextForAnalytics(title)
  const typeText = type ? `:${type}` : ""
  return JSON.stringify({
    eventAction: `pdp:installation and support${typeText}${addedTitle}`,
    eventName: `pdp:installation and support${typeText}${addedTitle}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sanitizeTextForAnalytics(title),
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:navigation",
    internalLinkZoneName: "pdp:installation and support",
    internalLinkURL: url
      ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
      : "n/a",
    clickInternalLinks: "true",
  })
}
